module.exports = __webpack_public_path__ + "img/orangePill.9df50482.svg";